import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function UrgencySection() {
  return <section className="py-16 px-4 bg-brand-red text-white text-center" data-id="element-282">
      <div className="max-w-3xl mx-auto" data-id="element-283">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-284">
          <div className="flex justify-center mb-4" data-id="element-285">
            <Clock className="w-12 h-12 animate-pulse" data-id="element-286" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold font-heading" data-id="element-287">
            Este precio de $6.36 es de lanzamiento.
          </h2>

          <p className="text-xl md:text-2xl font-medium text-white/90" data-id="element-288">
            Pronto volverá a su precio regular.
          </p>

          

          <div className="bg-white/10 p-6 rounded-xl border border-white/20 mb-8" data-id="element-289">
            <p className="text-xl font-bold" data-id="element-290">
              Tu próximo antojo va a llegar. Eso es inevitable.
              <br data-id="element-291" />
              ¿Vas a tener la respuesta correcta lista?
            </p>
          </div>

          <CTAButton pulsing className="bg-white text-brand-red hover:bg-gray-100 shadow-2xl" data-id="element-292">
            OBTENER EL SISTEMA ANTI-ANTOJO — $6.36
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}